import {
  EDITAR_TURNO,
  EDITAR_TURNO_EXITO,
  EDITAR_TURNO_ERROR
} from '../types';

import clienteAxios from '../config/axios';

export function editarTurnoAction(informacion) {
    return async (dispatch) => {
        dispatch(editarTurno());

        try {
            const { config, payload } = informacion;

            const respuesta = await clienteAxios.post(
                '/paciente/editarturno',
                payload,
                config
            );

            dispatch(editarTurnoExito(respuesta.data));

            return respuesta.data;

        } catch (error) {
            const mensajeError =
                error.response?.data?.msg ||
                error.response?.data?.message ||
                error.response?.data?.error ||
                'No se pudo editar el turno';

            dispatch(editarTurnoError(mensajeError));

            error.userMessage = mensajeError;

            throw error;
        }
    };
}

const editarTurno = () => ({
    type: EDITAR_TURNO,
    payload: true
});

const editarTurnoExito = (data) => ({
    type: EDITAR_TURNO_EXITO,
    payload: data
});

const editarTurnoError = (msg) => ({
    type: EDITAR_TURNO_ERROR,
    payload: msg
});